import Inputer from 'Utils/Helpers/Inputer';
import { TextShow } from 'Utils/Helpers/TextShow';
import { useDispatch } from 'react-redux';
import * as icons from 'react-bootstrap-icons';
import { changeCounts } from '../../../../../Redux/slices/globalSlice';

export default function Limits({ weeklyLimit }) {
    const dispatch = useDispatch();

    const setControlsValue = (name, value) => {
        dispatch(changeCounts({ index: +name, count: +value }))
    }

    return (
        <div>
            <TextShow
                title={"تنظیم تعداد نوبت در روز"}
                icon={<icons.FilterCircle size={18} />}
                justText
                className={'no-hide text-muted'}
            />
            <div className='mt-2 flex-row-between-center flex-wrap' style={{padding: '0 10px'}}>
                {
                    weeklyLimit ? weeklyLimit.map((items, index) => {
                        return (
                            <Inputer
                                key={`inputer_${index}`}
                                id={index}
                                type={'number'}
                                placeholder={items.day}
                                value={items.count}
                                setValue={setControlsValue.bind(this)}
                                icon={<icons.SortNumericDown/>}
                                className={'day-count'}
                            />
                        )
                    }) : <small className='each-status w-100 text-center mb-2'>{"تعداد نوبت در روز به درستی بارگزاری نشده‌اند"}</small>
                }
            </div>
        </div>
    );
}